<template>
	<div class="mt-4">
		<b-modal ref="loaderModal"
			hide-footer
			:title="$t('Button.loader')">
			<throbber />
			<p class="my-4">{{ $t('Tooltip.message_wait') }}</p>
		</b-modal>
		<b-modal ref="modalError"
			hide-footer
			:title="$t('Errors.error')">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<div class="valid_button">
			<button type="submit"
				class="btn btn-valid"
				@click.prevent="sendDatas"
				:disabled = disabled
			>{{ $t('Detail.validButtonText') }}
			</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import {EventBus} from "../../../event/event-bus";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "ValidStepDetail",
	components: {lottie_error, throbber},
	props: {
		value: {
			type: String,
			required: true,
		},
		contentValue: {
			type: String,
			required: true,
		},
		id: {
			type: Number,
			required: true,
		},
		disabled: Boolean,
		music_enabled: Boolean,
		music_volume: Number,
	},
	data() {
		return {
			text_error: "",
		};
	},
	created() {
		let $this = this;
		EventBus.$on("setLanguage", lang => {
			$this.$i18n.locale = lang;
		});
	},
	deactivated() {
		EventBus.$off("setLanguage");
	},
	methods: {
		sendDatas() {
			let $this = this;
			$this.$refs.loaderModal.show();
			let bodyFormData = new FormData();
			bodyFormData.append("_method", "put");
			if (this.value !== undefined && this.value !== null) {
				bodyFormData.append("title", this.value);
				bodyFormData.append("isCompleted", "1");
			}

			if (this.music_enabled !== undefined) {
				bodyFormData.append("music_enabled", this.music_enabled ? "true" : "false");
			}
			if (this.music_volume !== undefined) {
				bodyFormData.append("music_volume", this.music_volume.toString());
			}

			if (this.contentValue !== undefined && this.contentValue !== null) {
				bodyFormData.append("content", this.contentValue);
			}
			axios.post(BASE_URL + "/public/api/stepDetails/" + $this.id,
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.$refs.loaderModal.hide();
				if ($this.value.length > 0) {
					EventBus.$emit("setStepDetailComplete", $this.id);
				}
				EventBus.$emit("setModificationTitleLabel", "");
				EventBus.$emit("setModificationContentLabel", "");
				EventBus.$emit("setModified", false);
			}).catch(error => {
				$this.text_error = $this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
				$this.$refs.loaderModal.hide();
			});
		},
	},
};
</script>

<style scoped>
.btn-valid {
	background-color: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
	border-radius: var(--small-border-radius);
}
/*
.btn-valid:hover {
	background-color: #53565A;
	border-color: #53565A;
	color: white;
}*/
</style>
